module.exports = __webpack_public_path__ + "img/7.d2604e4f.png";